export const SEO_DATA = {
  home: {
    title: "Ekalsutra - School Management ERP Software 2025",
    description: "Transform your school with Ekalsutra's ERP software. 11+ modules for fee management, attendance, admissions & mobile apps. Trusted by 200+ schools.",
    keywords: "school management software, school ERP, education management system, fee management software, attendance tracking, admission management, school administration software, student information system, parent portal, staff management, school mobile app",
    canonical: "https://ekalsutra.com/",
    ogImage: "/landingPage/homeImg.svg",
    twitterCard: "summary_large_image",
    twitterTitle: "Ekalsutra - Complete School Management ERP Software",
    twitterDescription: "Comprehensive school management software with 11+ modules, mobile apps, and 24/7 support. Trusted by 200+ schools across India.",
    twitterImage: "/landingPage/homeImg.svg"
  },
  
  aboutUs: {
    title: "About Ekalsutra - Leading School Management Software Company | Our Story",
    description: "Learn about Ekalsutra's journey in transforming school education through innovative ERP software. Founded with a mission to simplify school administration and enhance educational experiences across India.",
    keywords: "about ekalsutra, school software company, education technology, school management solutions, edtech company India",
    canonical: "https://ekalsutra.com/about-us",
    ogImage: "/landingPage/about-us/about-us-head.svg",
    twitterCard: "summary_large_image",
    twitterTitle: "About Ekalsutra - Leading School Management Software Company",
    twitterDescription: "Learn about our journey in transforming school education through innovative ERP software solutions.",
    twitterImage: "/landingPage/about-us/about-us-head.svg"
  },
  
  features: {
    title: "School Management Software Features | 11+ Modules | Ekalsutra ERP",
    description: "Explore comprehensive features of Ekalsutra school management software: fee management, attendance tracking, admission management, academic details, transport management, library management, and mobile apps.",
    keywords: "school software features, fee management system, attendance management, admission software, academic management, transport tracking, library management, examination system",
    canonical: "https://ekalsutra.com/features",
    ogImage: "/landingPage/features/mobile_1.png",
    twitterCard: "summary_large_image",
    twitterTitle: "School Management Software Features | 11+ Modules",
    twitterDescription: "Comprehensive features: fee management, attendance tracking, admission management, and 11+ modules for complete school administration.",
    twitterImage: "/landingPage/features/mobile_1.png"
  },
  
  pricing: {
    title: "School Management Software Pricing | Affordable ERP Plans | Ekalsutra",
    description: "Get transparent pricing for Ekalsutra school management software. Choose from flexible plans designed for schools of all sizes. Contact us for customized pricing and special discounts.",
    keywords: "school software pricing, school ERP cost, education software price, school management system cost, affordable school software",
    canonical: "https://ekalsutra.com/pricing",
    ogImage: "/landingPage/homeImg.svg",
    twitterCard: "summary_large_image",
    twitterTitle: "School Management Software Pricing | Affordable ERP Plans",
    twitterDescription: "Transparent pricing for school management software. Flexible plans for schools of all sizes with special discounts.",
    twitterImage: "/landingPage/homeImg.svg"
  },
  
  services: {
    title: "School Management Services | ERP Implementation & Support | Ekalsutra",
    description: "Complete school management services including ERP implementation, data migration, training, ongoing support, and custom development. Expert team ensures smooth transition to digital school management.",
    keywords: "school ERP services, implementation services, data migration, training support, school software consulting",
    canonical: "https://ekalsutra.com/services",
    ogImage: "/landingPage/weProvide/school-management.png",
    twitterCard: "summary_large_image",
    twitterTitle: "School Management Services | ERP Implementation & Support",
    twitterDescription: "Complete services: ERP implementation, data migration, training, and ongoing support for smooth digital transformation.",
    twitterImage: "/landingPage/weProvide/school-management.png"
  },
  
  contactUs: {
    title: "Contact Ekalsutra | School Management Software Support | Get Demo",
    description: "Contact Ekalsutra for school management software demo, pricing information, or technical support. Reach our expert team via phone, email, or online form. Quick response guaranteed.",
    keywords: "contact ekalsutra, school software demo, technical support, sales inquiry, customer service",
    canonical: "https://ekalsutra.com/contact-us",
    ogImage: "/landingPage/homeImg.svg",
    twitterCard: "summary_large_image",
    twitterTitle: "Contact Ekalsutra | Get School Software Demo",
    twitterDescription: "Contact us for demo, pricing, or support. Quick response guaranteed from our expert team.",
    twitterImage: "/landingPage/homeImg.svg"
  },
  
  partners: {
    title: "Become a Partner | School Software Reseller Program | Ekalsutra",
    description: "Join Ekalsutra's partner program and become a school management software reseller. Earn attractive commissions, get marketing support, and grow your education technology business.",
    keywords: "partner program, reseller opportunity, education technology partner, school software distributor",
    canonical: "https://ekalsutra.com/become-a-partners",
    ogImage: "/landingPage/homeImg.svg",
    twitterCard: "summary_large_image",
    twitterTitle: "Become a Partner | School Software Reseller Program",
    twitterDescription: "Join our partner program. Earn attractive commissions and grow your education technology business.",
    twitterImage: "/landingPage/homeImg.svg"
  },
  
  careers: {
    title: "Careers at Ekalsutra | Join Our Education Technology Team",
    description: "Explore exciting career opportunities at Ekalsutra. Join our passionate team working on innovative school management solutions. Current openings in development, sales, support, and more.",
    keywords: "ekalsutra careers, education technology jobs, software developer jobs, sales jobs, edtech careers",
    canonical: "https://ekalsutra.com/careers",
    ogImage: "/landingPage/team/team.jpeg",
    twitterCard: "summary_large_image",
    twitterTitle: "Careers at Ekalsutra | Join Our Education Technology Team",
    twitterDescription: "Exciting career opportunities in education technology. Join our passionate team working on innovative school management solutions.",
    twitterImage: "/landingPage/team/team.jpeg"
  },
  
  blogs: {
    title: "School Management Blog | Education Technology Insights | Ekalsutra",
    description: "Read the latest insights on school management, education technology trends, digital transformation in schools, and best practices for educational institutions.",
    keywords: "school management blog, education technology, digital transformation, school administration tips, edtech insights",
    canonical: "https://ekalsutra.com/blogs",
    ogImage: "/landingPage/homeImg.svg",
    twitterCard: "summary_large_image",
    twitterTitle: "School Management Blog | Education Technology Insights",
    twitterDescription: "Latest insights on school management, edtech trends, and digital transformation best practices.",
    twitterImage: "/landingPage/homeImg.svg"
  },
  
  privacyPolicy: {
    title: "Privacy Policy | Data Protection | Ekalsutra School Management Software",
    description: "Ekalsutra's privacy policy explaining how we collect, use, and protect your personal data. We are committed to maintaining the highest standards of data security and privacy.",
    keywords: "privacy policy, data protection, GDPR compliance, data security",
    canonical: "https://ekalsutra.com/privacy-policy",
    ogImage: "/landingPage/homeImg.svg",
    twitterCard: "summary_large_image",
    twitterTitle: "Privacy Policy | Data Protection | Ekalsutra",
    twitterDescription: "Learn how we collect, use, and protect your personal data with the highest standards of security.",
    twitterImage: "/landingPage/homeImg.svg",
    noIndex: false
  },
  
  termAndConditions: {
    title: "Terms and Conditions | Service Agreement | Ekalsutra",
    description: "Read Ekalsutra's terms and conditions for using our school management software and services. Understand your rights and responsibilities as our valued customer.",
    keywords: "terms and conditions, service agreement, terms of use",
    canonical: "https://ekalsutra.com/term-and-conditions",
    ogImage: "/landingPage/homeImg.svg",
    twitterCard: "summary_large_image",
    twitterTitle: "Terms and Conditions | Service Agreement | Ekalsutra",
    twitterDescription: "Understand your rights and responsibilities when using our school management software and services.",
    twitterImage: "/landingPage/homeImg.svg",
    noIndex: false
  },
  
  refundPolicy: {
    title: "Refund Policy | Money Back Guarantee | Ekalsutra",
    description: "Ekalsutra's transparent refund policy for school management software services. Learn about our money-back guarantee and refund process for customer satisfaction.",
    keywords: "refund policy, money back guarantee, customer satisfaction",
    canonical: "https://ekalsutra.com/refund-policy",
    ogImage: "/landingPage/homeImg.svg",
    twitterCard: "summary_large_image",
    twitterTitle: "Refund Policy | Money Back Guarantee | Ekalsutra",
    twitterDescription: "Transparent refund policy with money-back guarantee for complete customer satisfaction.",
    twitterImage: "/landingPage/homeImg.svg",
    noIndex: false
  }
};

// Location-specific SEO data for local SEO
export const LOCATION_SEO_DATA = {
  delhi: {
    title: "School Management Software in Delhi | Best ERP for Delhi Schools | Ekalsutra",
    description: "Leading school management software provider in Delhi NCR. Trusted by Delhi schools for comprehensive ERP solutions including fee management, attendance, and mobile apps.",
    keywords: "school management software Delhi, school ERP Delhi NCR, education software Delhi, school administration Delhi",
    canonical: "https://ekalsutra.com/school-management-software-delhi",
    ogImage: "/landingPage/homeImg.svg",
    twitterCard: "summary_large_image",
    twitterTitle: "School Management Software in Delhi | Best ERP for Delhi Schools",
    twitterDescription: "Leading school management software provider in Delhi NCR. Comprehensive ERP solutions for Delhi schools.",
    twitterImage: "/landingPage/homeImg.svg"
  },
  
  mumbai: {
    title: "School Management Software in Mumbai | Maharashtra School ERP | Ekalsutra",
    description: "Top school management software for Mumbai and Maharashtra schools. Complete ERP solution with fee management, student information system, and parent communication portal.",
    keywords: "school management software Mumbai, school ERP Maharashtra, education software Mumbai, school system Mumbai",
    canonical: "https://ekalsutra.com/school-management-software-mumbai",
    ogImage: "/landingPage/homeImg.svg",
    twitterCard: "summary_large_image",
    twitterTitle: "School Management Software in Mumbai | Maharashtra School ERP",
    twitterDescription: "Top school management software for Mumbai and Maharashtra schools. Complete ERP solution with advanced features.",
    twitterImage: "/landingPage/homeImg.svg"
  },
  
  bangalore: {
    title: "School Management Software in Bangalore | Karnataka School ERP | Ekalsutra",
    description: "Premier school management software for Bangalore and Karnataka schools. Advanced ERP features for modern educational institutions with mobile accessibility.",
    keywords: "school management software Bangalore, school ERP Karnataka, education technology Bangalore, school software Bengaluru",
    canonical: "https://ekalsutra.com/school-management-software-bangalore",
    ogImage: "/landingPage/homeImg.svg",
    twitterCard: "summary_large_image",
    twitterTitle: "School Management Software in Bangalore | Karnataka School ERP",
    twitterDescription: "Premier school management software for Bangalore schools. Advanced ERP features with mobile accessibility.",
    twitterImage: "/landingPage/homeImg.svg"
  },
  
  pune: {
    title: "School Management Software in Pune | Maharashtra Education ERP | Ekalsutra",
    description: "Comprehensive school management software for Pune schools. Digital transformation solutions for educational institutions with complete administrative automation.",
    keywords: "school management software Pune, school ERP Pune, education software Maharashtra, school administration Pune",
    canonical: "https://ekalsutra.com/school-management-software-pune",
    ogImage: "/landingPage/homeImg.svg",
    twitterCard: "summary_large_image",
    twitterTitle: "School Management Software in Pune | Maharashtra Education ERP",
    twitterDescription: "Comprehensive school management software for Pune schools. Complete administrative automation solutions.",
    twitterImage: "/landingPage/homeImg.svg"
  }
};

// Feature-specific SEO data
export const FEATURE_SEO_DATA = {
  feeManagement: {
    title: "Fee Management Software | Online Fee Collection System | Ekalsutra",
    description: "Streamline school fee collection with Ekalsutra's automated fee management system. Online payments, fee tracking, receipts, and financial reporting in one platform.",
    keywords: "fee management software, online fee collection, school fee system, fee tracking, digital payments school",
    canonical: "https://ekalsutra.com/fee-management-software",
    ogImage: "/landingPage/features/mobile_1.png",
    twitterCard: "summary_large_image",
    twitterTitle: "Fee Management Software | Online Fee Collection System",
    twitterDescription: "Streamline school fee collection with automated system. Online payments, tracking, and financial reporting.",
    twitterImage: "/landingPage/features/mobile_1.png"
  },
  
  attendanceTracking: {
    title: "Student Attendance Management System | Digital Attendance | Ekalsutra",
    description: "Modern attendance management system for schools. Digital attendance tracking, real-time notifications to parents, and comprehensive attendance reports.",
    keywords: "attendance management system, digital attendance, student attendance tracking, attendance software, biometric attendance",
    canonical: "https://ekalsutra.com/attendance-management-system",
    ogImage: "/landingPage/features/mobile_1.png",
    twitterCard: "summary_large_image",
    twitterTitle: "Student Attendance Management System | Digital Attendance",
    twitterDescription: "Modern attendance management with digital tracking, real-time notifications, and comprehensive reports.",
    twitterImage: "/landingPage/features/mobile_1.png"
  },
  
  admissionManagement: {
    title: "School Admission Management System | Online Admission Portal | Ekalsutra",
    description: "Simplify school admissions with digital admission management system. Online applications, document verification, admission tracking, and automated workflows.",
    keywords: "admission management system, online admission portal, school admission software, digital admission process",
    canonical: "https://ekalsutra.com/admission-management-system",
    ogImage: "/landingPage/features/mobile_1.png",
    twitterCard: "summary_large_image",
    twitterTitle: "School Admission Management System | Online Admission Portal",
    twitterDescription: "Simplify school admissions with digital system. Online applications, document verification, and automated workflows.",
    twitterImage: "/landingPage/features/mobile_1.png"
  },
  
  parentPortal: {
    title: "Parent Communication Portal | School Parent App | Ekalsutra",
    description: "Keep parents connected with dedicated parent portal and mobile app. Real-time updates on attendance, fees, academic progress, and school announcements.",
    keywords: "parent portal, school parent app, parent communication, school mobile app, parent engagement",
    canonical: "https://ekalsutra.com/parent-communication-portal",
    ogImage: "/landingPage/features/mobile_1.png",
    twitterCard: "summary_large_image",
    twitterTitle: "Parent Communication Portal | School Parent App",
    twitterDescription: "Keep parents connected with dedicated portal and mobile app. Real-time updates and communication.",
    twitterImage: "/landingPage/features/mobile_1.png"
  }
};
